<template>
    <div class="span4">
        <p style="margin: 0 auto;">
            <b>{{ resource["title"] }}</b>
        </p>
        <div
            id="sub-chart2"
            style="width: 90%; height: 250px; overflow-y: inherit;"
        >
            <loader-barchart v-if="isLoading" />
        </div>
    </div>
    <!--/row-->
</template>

<script>
export default {
    components: {
        LoaderBarchart: () => import("@/components/elements/loader-barchart")
    },
    data() {
        return {
            isLoading: false,
            resource: "",
            params: "",
            code: ""
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let self = this;
            self.isLoading = true;

            this.$http
                .get(
                    process.env.BARRACUDA +
                        "report/patient/total_active_patients"
                )
                .then(function (response) {
                    self.isLoading = false;
                    self.resource = response.data.response.resources;
                    self.code = response.data.response.message["code"];
                    self.params = {
                        results: response.data.response.resources["results"],
                        xaxis: response.data.response.resources["xaxis"]
                    };
                    if (self.code === 200) {
                        self.render_graph(self.params);
                    }
                });
        },
        render_graph(params) {
            let self = this;
            var data = [
                {
                    label: "",
                    data: params.results,
                    color: "#D2ECAB"
                }
            ];

            var options = {
                series: {
                    bars: {
                        show: true,
                        fill: true,
                        barWidth: 0.9,
                        align: "center"
                    },
                    points: {
                        show: false
                    }
                },
                grid: {
                    borderWidth: 0,
                    hoverable: false
                },
                xaxis: {
                    ticks: params.xaxis
                },
                yaxis: {
                    axisLabelUseCanvas: false,
                    tickDecimals: 0,
                    tickFormatter: function numberWithCommas(x) {
                        return x
                            .toString()
                            .replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
                    }
                },
                tooltip: true,
                tooltipOpts: {
                    content: "%p.0%, %s",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                }
            };

            $.plot($("#sub-chart2"), data, options);
            $(window).resize(function () {
                if (
                    self.$router.history.current.path == "/report/dashboard" ||
                    self.$router.history.current.path == "/patient/dashboard"
                ) {
                    $.plot($("#sub-chart2"), data, options);
                }
            });
        }
    }
};
</script>
